import { Prettify } from '@frontend/types';
import { ButtonProps } from '@frontend/design-system';
import { CardOnFileNoGatewayPlaceholder } from '../../../components/card-on-file/placeholders/no-gateway-placeholder';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { useProcessorDataContext } from '../../../contexts/processor-data.context';
import { CardOnFileProps } from '../../card-on-file';
import { CardOnFileJustifiProvider } from './card-on-file-justifi.context';
import { CardOnFileStripeProvider } from './card-on-file-stripe.context';

export type CardOnFileBaseContext = {
  onSubmit: () => Promise<void>;
  primary: ButtonProps;
  secondary: ButtonProps;
  shouldShowFooter: boolean;
  shouldShowLoading: boolean;
};

export type CardOnFileProviderProps = Prettify<Omit<CardOnFileProps, 'locationId' | 'merchant'>>;

export const CardOnFileProvider = ({ children, noGatewayPlaceholder, ...props }: CardOnFileProviderProps) => {
  const { activeGateway, merchantIsFetched } = useProcessorDataContext();

  if (!activeGateway) {
    if (merchantIsFetched) {
      return noGatewayPlaceholder ?? <CardOnFileNoGatewayPlaceholder onClose={props.onCancel} />;
    }

    return null; // Wait for merchant data to be fetched
  }

  return (
    <GatewaySwitch
      stripeProps={props}
      stripeContent={CardOnFileStripeProvider}
      justifiProps={props}
      justifiContent={CardOnFileJustifiProvider}
    >
      {children}
    </GatewaySwitch>
  );
};
